/**
 * Strategy IDs for StrategyBenchmarkChart align with backend strategy / resource
 * naming (e.g. highs_and_lows_table). SiD dashboard uses highs_and_lows as the
 * umbrella ID for the Swing and Direction (Highs & Lows) strategy.
 */
export const STRATEGY_BENCHMARK_CHART_STRATEGY_IDS = Object.freeze({
  HIGHS_AND_LOWS: "highs_and_lows",
  SUPPLY_DEMAND: "supply_demand",
  DONCHAIN_H4: "donchain_h4",
  TREND: "trend"
});

export const STRATEGY_BENCHMARK_CHART_STRATEGIES = Object.freeze(
  Object.values(STRATEGY_BENCHMARK_CHART_STRATEGY_IDS)
);

export const STRATEGY_BENCHMARK_CHART_FULLSCREEN_KEY =
  "strategy_benchmark_chart_fullscreen";

/**
 * Shared chart chrome — reused from SiD keys (same backend copy for all strategies).
 * Strategy-specific naming stays in strategyLabelKey only.
 */
export const STRATEGY_BENCHMARK_CHART_TITLE_KEY =
  "strategy_benchmark_chart_title_highs_and_lows";
export const STRATEGY_BENCHMARK_CHART_DESCRIPTION_KEY =
  "strategy_benchmark_chart_description_highs_and_lows";

export const STRATEGY_BENCHMARK_CHART_COMPARISON_LABEL_KEYS = Object.freeze({
  wig20: "strategy_benchmark_chart_comparison_wig20",
  mwig40: "strategy_benchmark_chart_comparison_mwig40",
  swig80: "strategy_benchmark_chart_comparison_swig80"
});

export const STRATEGY_BENCHMARK_CHART_CONFIG = Object.freeze({
  [STRATEGY_BENCHMARK_CHART_STRATEGY_IDS.HIGHS_AND_LOWS]: {
    titleKey: STRATEGY_BENCHMARK_CHART_TITLE_KEY,
    descriptionKey: STRATEGY_BENCHMARK_CHART_DESCRIPTION_KEY,
    strategyLabelKey: "strategy_benchmark_chart_strategy_label_highs_and_lows"
  },
  [STRATEGY_BENCHMARK_CHART_STRATEGY_IDS.SUPPLY_DEMAND]: {
    titleKey: STRATEGY_BENCHMARK_CHART_TITLE_KEY,
    descriptionKey: STRATEGY_BENCHMARK_CHART_DESCRIPTION_KEY,
    strategyLabelKey: "strategy_benchmark_chart_strategy_label_supply_demand"
  },
  [STRATEGY_BENCHMARK_CHART_STRATEGY_IDS.DONCHAIN_H4]: {
    titleKey: STRATEGY_BENCHMARK_CHART_TITLE_KEY,
    descriptionKey: STRATEGY_BENCHMARK_CHART_DESCRIPTION_KEY,
    strategyLabelKey: "strategy_benchmark_chart_strategy_label_donchain_h4"
  },
  [STRATEGY_BENCHMARK_CHART_STRATEGY_IDS.TREND]: {
    titleKey: STRATEGY_BENCHMARK_CHART_TITLE_KEY,
    descriptionKey: STRATEGY_BENCHMARK_CHART_DESCRIPTION_KEY,
    strategyLabelKey: "strategy_benchmark_chart_strategy_label_trend"
  }
});

export function isValidStrategyBenchmarkChartStrategy(strategy) {
  return STRATEGY_BENCHMARK_CHART_STRATEGIES.includes(strategy);
}

export function getStrategyBenchmarkChartConfig(strategy) {
  if (!isValidStrategyBenchmarkChartStrategy(strategy)) {
    throw new Error(
      `Invalid strategy "${strategy}". Valid values: ${STRATEGY_BENCHMARK_CHART_STRATEGIES.join(
        ", "
      )}`
    );
  }

  return STRATEGY_BENCHMARK_CHART_CONFIG[strategy];
}
